/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubIvcWaybillVo
 */
export interface SubIvcWaybillVo {
    /**
     * 运单id
     * @type {number}
     * @memberof SubIvcWaybillVo
     */
    id?: number;
    /**
     * 子单号
     * @type {string}
     * @memberof SubIvcWaybillVo
     */
    subIVC?: string;
}

/**
 * Check if a given object implements the SubIvcWaybillVo interface.
 */
export function instanceOfSubIvcWaybillVo(value: object): value is SubIvcWaybillVo {
    return true;
}

export function SubIvcWaybillVoFromJSON(json: any): SubIvcWaybillVo {
    return SubIvcWaybillVoFromJSONTyped(json, false);
}

export function SubIvcWaybillVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubIvcWaybillVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'subIVC': json['subIVC'] == null ? undefined : json['subIVC'],
    };
}

export function SubIvcWaybillVoToJSON(json: any): SubIvcWaybillVo {
    return SubIvcWaybillVoToJSONTyped(json, false);
}

export function SubIvcWaybillVoToJSONTyped(value?: SubIvcWaybillVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'subIVC': value['subIVC'],
    };
}

